import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from '@/context/ThemeContext';
import '@/i18n';

// Layout
import { Layout } from '@/components/Layout';

// Public Pages
import { Home } from '@/pages/Home';
import { About } from '@/pages/About';
import { Services } from '@/pages/Services';
import { ServiceDetail } from '@/pages/ServiceDetail';
import { Industries } from '@/pages/Industries';
import { WorkingModel } from '@/pages/WorkingModel';
import { Legal } from '@/pages/Legal';
import { Contact } from '@/pages/Contact';

// Admin Pages
import { AdminLogin } from '@/pages/admin/AdminLogin';
import { AdminDashboard } from '@/pages/admin/AdminDashboard';
import { AdminLeads } from '@/pages/admin/AdminLeads';
import { AdminContent } from '@/pages/admin/AdminContent';
import { AdminPartners } from '@/pages/admin/AdminPartners';
import { AdminServices } from '@/pages/admin/AdminServices';
import { AdminSettings } from '@/pages/admin/AdminSettings';
import { AdminContactInfo } from '@/pages/admin/AdminContactInfo';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes with Layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/services" element={<Layout><Services /></Layout>} />
            <Route path="/services/:slug" element={<Layout><ServiceDetail /></Layout>} />
            <Route path="/industries" element={<Layout><Industries /></Layout>} />
            <Route path="/working-model" element={<Layout><WorkingModel /></Layout>} />
            <Route path="/legal" element={<Layout><Legal /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />

            {/* Admin Routes without Layout */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/leads" element={<AdminLeads />} />
            <Route path="/admin/content" element={<AdminContent />} />
            <Route path="/admin/partners" element={<AdminPartners />} />
            <Route path="/admin/services" element={<AdminServices />} />
            <Route path="/admin/settings" element={<AdminSettings />} />
            <Route path="/admin/contact-info" element={<AdminContactInfo />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </ThemeProvider>
    </div>
  );
}

export default App;
